<template>
    <div>
        <div v-if="data.type=='VEHICLE'">
            <b-icon icon="truck"/> <VehicleBrief :label=data.id :showGps=false :showLink=false />
        </div>
        <div v-else>
            {{ data.type }}-{{ data.id }}
        </div>
    </div>
</template>

<script>
import VehicleBrief from '@/components/Realtime/VehicleBrief'
export default {
    name:"EventAddress",
    components: { VehicleBrief },
    props: {
        data: null 
    }
}
</script>